module.exports = __webpack_public_path__ + "img/w3.fb7367ca.png";